import { useState } from "react";
import { Input } from "@/components/ui/input";
import { PackageCheck, Home as Shop, Ban, Wrench, Truck, LogOut } from "lucide-react";

// What this person may do from the Sales menu. A button names the item; there is no "are you sure?" — the
// message that follows carries Undo.
const big = "w-full justify-start inline-flex items-center gap-2 h-12 px-4 rounded-lg text-sm font-bold disabled:opacity-40";
const red = `${big} bg-[#B01E28] hover:bg-[#8B1820] text-white`;
const plain = `${big} border-2 border-slate-300 bg-white hover:bg-slate-50 text-slate-800`;

export function SalesActions({ s, kind, label, act }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async (m, p, b) => { setBusy(true); await act(m, p, b); setBusy(false); };
  const has = (k) => k in s.marks;
  const mark = (k) => (has(k) ? go("delete", `/mark/${k}`) : go("post", `/mark/${k}`, {}));
  if (!s.can.prepare && !s.can.not_needed) return null;
  return (
    <div data-testid="sales-menu-actions" className="space-y-2">
      {kind === "part" && s.can.prepare && !s.in_queue && !has("keep_for_shop") && (
        <div data-testid="sales-nominate" className="space-y-2 rounded-lg border border-slate-200 p-2">
          <Input data-testid="sales-nominate-reason" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Why sell it? e.g. fits nothing we build" className="h-11" />
          <button type="button" data-testid="sales-nominate-go" disabled={busy || reason.trim().length < 3 || !s.complete}
            onClick={() => go("post", "/nominate", { reason: reason.trim() })} className={red}>
            <PackageCheck className="w-4 h-4" />Nominate {label} for sale</button>
        </div>
      )}
      {kind === "truck" && s.can.prepare && s.builder && !has("recon_finished") && (
        <button type="button" data-testid="sales-recon-finished" disabled={busy || has("keep_for_shop")} onClick={() => mark("recon_finished")} className={red}>
          <Wrench className="w-4 h-4" />Recon finished — {label} goes up for sale</button>
      )}
      {kind === "truck" && s.can.prepare && !has("sell_whole") && (
        <button type="button" data-testid="sales-sell-whole" disabled={busy || has("keep_for_shop")} onClick={() => mark("sell_whole")} className={s.builder ? plain : red}>
          <Truck className="w-4 h-4" />Sell {label} whole</button>
      )}
      {kind === "part" && s.can.not_needed && (
        <button type="button" data-testid="sales-not-needed" disabled={busy} onClick={() => mark("not_needed")} className={plain}>
          <Ban className="w-4 h-4" />{has("not_needed") ? "Take off \"Not needed for our work\"" : "Not needed for our work"}</button>
      )}
      {s.can.prepare && !s.in_queue && (
        <button type="button" data-testid="sales-keep-for-shop" disabled={busy} onClick={() => mark("keep_for_shop")} className={plain}>
          <Shop className="w-4 h-4" />{has("keep_for_shop") ? "Take off Keep for the shop" : "Keep for the shop"}</button>
      )}
      {s.can.prepare && s.in_queue && (
        <button type="button" data-testid="sales-take-out" disabled={busy} onClick={() => go("post", "/take-out")} className={plain}>
          <LogOut className="w-4 h-4" />Take {label} out of the sales queue</button>
      )}
    </div>
  );
}
